import { getTranslate } from 'react-localize-redux';
import { getStore } from '../store/createStore';

export function createReduxTimeoutMiddleware(dispatch, state) {
  return (middlewareApi) => (next) => {
    const state = getStore().getState();
    const translate = getTranslate(state.locale);
    next(translate('common.timeout'));
  };
}
